import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { set_session_expiry_from_response } from '@/utils/auth/session_manager';

export default {
  name: 'UserLogin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },
  mounted() {
    const redirect_reason = sessionStorage.getItem('auth_redirect_reason');
    if (redirect_reason) {
      sessionStorage.removeItem('auth_redirect_reason');
      this.show_error(redirect_reason);
    }
  },
  methods: {
    async login_function() {
      if (!this.username || !this.password) return;

      this.verification_running = true;

      try {
        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password
        });

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        sessionStorage.setItem('token', response_data.token);
        sessionStorage.setItem('is_aic_one_login', false);
        set_session_expiry_from_response(response_data);

        this.$store.dispatch('setCurrentUserId', response_data.user_id);
        this.$store.dispatch('setCurrentLeadId', response_data.lead_id);
        this.$store.dispatch('setCurrentRole', response_data.role_type);
        this.$store.dispatch('setCurrentLeadName', response_data.full_name);

        this.$router.push('/one_time_pin');
      } catch (error) {
        console.error('Login failed', error);
        this.show_error(
          error?.response?.data?.message || 'Login failed. Please check your credentials.'
        );
      } finally {
        this.verification_running = false;
      }
    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
